export enum PasskeyDeviceTypesOptions {
	SINGLE_DEVICE = 'singleDevice',
	MULTI_DEVICE = 'multiDevice'
}

export type Passkey = {
	id: string;
	name?: string;
	deviceType: PasskeyDeviceTypesOptions;
	backedUp: boolean;
	transports?: string[];
	createdAt: number;
	lastUsedAt?: number;
};
